<template>
<router-link
    v-if="item"
    class="search-result-item is-block"
    :to="item.url"
>
    <p class="search-result-item--tags" v-if="item.tags">
        <span
            class="button is-small is-purple is-rounded is-outlined not-hoverable"
            v-for="tag in item.tags"
            :key="`tag-${tag.id}`"
        >
            {{ tag.title }}
        </span>
    </p>
    <h3 class="title">{{ item.title }}</h3>
    <div class="content" v-html="item.content"></div>
</router-link>
</template>

<script>
export default {
    name: "SearchResultItem",
    props: ["item"]
}
</script>

<style lang="scss" scoped>
.search-result-item {
    &--tags {
        margin-bottom: -.75rem;
        span.button {
            margin-bottom: .75rem;
            &:not(:last-child) {
                margin-right: .75em;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/blocks/modules/search/SearchResultItem.vue